import React, { useEffect, useState } from "react";
// import { IArticle } from "../order/orderDetail";
import AmountInput from "../AmountInput/AmountInput";
import { useActiveSalesWrapStore, useSelectedArticleStore } from "../../store/store";
import classNames from "classnames";
import { Article } from "../../api/order/generated/src";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

interface IArticleDetailProps {
    // articleId:string;

    article:Article;
}


interface IArticleAmount {
    articleId: string;
    batch?:string;
    serial?:string;
    value: number;
}

const ArticleDetail = (props:IArticleDetailProps) => {
    const { article } = props;

    const { t } = useTranslation();

    const selectedArticle = useSelectedArticleStore(state => state.article);

    const setSelectedArticle = useSelectedArticleStore(state => state.updateSelected);

        
    

    const [tmpArticle, setTmpArticle] = useState<Article>(article);

    useEffect(() => {
        setTmpArticle(article);
    }, [article]);
    
    const incrementArticleAmount = (data:IArticleAmount) => {

        if(data.batch && data.batch !== ""){
            const batches = [...tmpArticle?.batchItems ?? []];

            const found = batches.find((b) => {
                return b.batch === data.batch;
            });

            if(found){
                const newBooked = (tmpArticle.quantityBooked ?? 0) + data.value;
                found.quantityBooked = (found.quantityBooked ?? 0) + data.value;

                setTmpArticle((old) => {
                    return {
                        ...old,
                        batchItems: [...batches],
                        booked: newBooked
                    }
                })
            }
        }
        else if(data.serial && data.serial !== ""){
            // const serials = [...tmpArticle?.serialItems ?? []];

            // const found = serials.find((b) => {
            //     return b.serial === data.batch;
            // });

            // if(found){
            //     const newBooked = tmpArticle.booked + data.value;
            //     found.booked = found.booked + data.value;

            //     setTmpArticle((old) => {
            //         return {
            //             ...old,
            //             serialItems: [...serials],
            //             booked: newBooked
            //         }
            //     })
            // }
        }
        else{
            const newBooked = (tmpArticle.quantityBooked ?? 0) + data.value;

            setTmpArticle((old) => {
                return {
                    ...old,
                    booked: newBooked
                }
            })
        }
        
    }

    const setArticleAmount = (data:IArticleAmount) => {
        if(data.batch && data.batch !== ""){
            const batches = [...tmpArticle?.batchItems ?? []];

            const found = batches.find((b) => {
                return b.batch === data.batch;
            });

            if(found){
                // const newBooked = tmpArticle.booked + data.value;
                found.quantityBooked = data.value;

                setTmpArticle((old) => {
                    return {
                        ...old,
                        batchItems: [...batches],
                        // booked: newBooked
                    }
                })
            }
        }
        else if(data.serial && data.serial !== ""){
            // const serials = [...tmpArticle?.serialItems ?? []];

            // const found = serials.find((b) => {
            //     return b.serial === data.batch;
            // });

            // if(found){
            //     const newBooked = tmpArticle.booked + data.value;
            //     found.booked = found.booked + data.value;

            //     setTmpArticle((old) => {
            //         return {
            //             ...old,
            //             serialItems: [...serials],
            //             booked: newBooked
            //         }
            //     })
            // }
        }
        else{
            const newBooked = data.value;

            setTmpArticle((old) => {
                return {
                    ...old,
                    booked: newBooked
                }
            })
        }
    }


    const renderBatch = () => {

        if(tmpArticle.batchItems != null && tmpArticle.batchItems.length > 0){
            const lines = tmpArticle.batchItems.map((lineItem) => {

                const articleSelected = tmpArticle.id === selectedArticle.id && lineItem.batch === selectedArticle.subId;

                return (
                    <div 
                        key={lineItem.batch}
                        className={classNames("flex flex-col p-2", {"rounded-md selected-subarticle border border-[green]": articleSelected})}

                        onClick={(event) => {
                            if(tmpArticle.id && lineItem.batch){
                                setSelectedArticle(tmpArticle.id, lineItem.batch);
                            }

                            event.preventDefault();
                            event.stopPropagation();
                        }}
                    >
                        <div 
                            className="flex flex-row"
                        >
                            
                            <div className="grow">
                                <div className="">
                                    {lineItem.batch}
                                </div>
                                <div className="flex flex-row gap-4">
                                    <div className="grow">{t("common:bestBefore")}</div>
                                    <div>
                                        {lineItem.bestBefore != null && format(lineItem.bestBefore, "dd.MM.yyyy")}
                                    </div>
                                </div>
                                <div className="flex flex-row gap-4">
                                    <div className="grow">{t("common:productiondate")}</div>
                                    <div>
                                        {lineItem.productionDate != null && format(lineItem.productionDate, "dd.MM.yyyy")}
                                    </div>
                                </div>
                            </div>
                            <div>{lineItem.quantityBooked}</div>
                        </div>


                        {articleSelected &&
                            <AmountInput onChange={(newVal: number, increment: boolean) => {

                                if(increment){
                                    incrementArticleAmount({articleId:selectedArticle.id, batch: selectedArticle.subId, value: newVal} );
                                }
                                else{
                                    setArticleAmount({articleId:selectedArticle.id, batch: selectedArticle.subId, value: newVal} );
                                }
                
                            }}/>
                        }

                    </div>                    
                );
            })

            return (
                <div className="flex flex-col gap-2">
                    {lines}
                </div>
            );
        }

        return null;
    }

    const renderSerial = () => {

        if(tmpArticle.serialItems != null && tmpArticle.serialItems.length > 0){
            const lines = tmpArticle.serialItems.map((lineItem) => {
                
                const articleSelected = tmpArticle.id === selectedArticle.id && lineItem.serial === selectedArticle.subId;

                return (
                    <div 
                        key={lineItem.serial}
                        className="flex flex-col"
                    >
                        <div 
                            className="flex flex-row"
                        >
                            
                            <div className="grow">
                                {lineItem.serial}
                            </div>
                            <div>{lineItem.quantityBooked}</div>
                        </div>

                        {/* {articleSelected &&
                            <AmountInput onChange={(newVal: number, increment: boolean) => {

                                if(increment){
                                    incrementArticleAmount({articleId:selectedArticle.id, serial: selectedArticle.subId, value: newVal} );
                                }
                                else{
                                    setArticleAmount({articleId:selectedArticle.id, serial: selectedArticle.subId, value: newVal} );
                                }
                
                            }}/>
                        } */}

                    </div>
                );
            })

            return (
                <div className="flex flex-col gap-2">
                    {lines}
                </div>
            );
        }

        return null;
    }

    const renderDefault = () => {

        if(!(tmpArticle.serialItems != null && tmpArticle.serialItems.length > 0) && !(tmpArticle.batchItems != null && tmpArticle.batchItems.length > 0)){
                
            const articleSelected = tmpArticle.id === selectedArticle.id && selectedArticle.subId === "";

            if(articleSelected){
                return <AmountInput onChange={(newVal: number, increment: boolean) => {

                    if(increment){
                        incrementArticleAmount({articleId:selectedArticle.id, value: newVal} );
                    }
                    else{
                        setArticleAmount({articleId:selectedArticle.id, value: newVal} );
                    }
    
                }}/>
            }
        }

        return null;
    }

    return (
        <div className="w-full  h-full">

            <div className="w-full">
                {/* <div>{article.title}</div> */}
                <div className="flex flex-col gap-4">

                    {renderBatch()}
                    {renderSerial()}
                    {renderDefault()}
            
                    
                </div>
            </div>
                    
        </div>
    )
};

export default ArticleDetail;
